import { NgModule } from '@angular/core';
import { CompaniesSearchButtonPipe } from './companies-search-button.pipe';

@NgModule({
  declarations: [CompaniesSearchButtonPipe],
  exports: [CompaniesSearchButtonPipe]
})
export class CompaniesSearchButtonModule { }